<template>
  <RF-Dialog
    :cpntLargura='"1180px"'
    :cpntStatus="''"
    :cpntOnFecharDialog='cpntFecharFormulario'>
    <template slot='titulo'>      
      <div class="dem-nova-titulo">
        <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
        Consultar de histórico
      </div>
    </template>

    <template slot='conteudo'>
      <div class="app-con-his">
        <!-- SETA O BOTÃO -->
        <App-Button :cpntClass="'btn btn-primary btn-sm'" @onClick="filtros = !filtros">{{ filtros === false ? 'Mais Filtros' : 'Menos Filtros' }}</App-Button>

        <!-- SETA A TELA DE PESQUISA -->
        <App-Historico :cpntFiltros="cpntFiltros" :cpntMostrarFiltros="filtros" :class="filtros === false ? 'ocultar-filtro' : ''" :cpntDialog="true"></App-Historico>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped> 
  .app-con-his > button {
    width: 100%;
    margin-bottom: 10px;
  }
</style>

<style>
/* .app-con-his > .ocultar-filtro > div > .app-his-filtro, */
/* .app-con-his > .ocultar-filtro > div > .app-his-botao {
  display: none !important;
} */
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        type: Object
      },

      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Historico': () => import('@/components/historico/Historico.vue')
    },
    data: function () {
      return {
        filtros: false
      }
    }
  }
</script>
